export const SET_TRANSPORTEURS = 'SET_TRANSPORTEURS'
export const ADD_TRANSPORTEUR = 'ADD_TRANSPORTEUR'
export const UPDATE_TRANSPORTEUR = 'UPDATE_TRANSPORTEUR'
export const DELETE_TRANSPORTEUR = 'DELETE_TRANSPORTEUR'
export const SET_FORFAITS = 'SET_FORFAITS'
export const SET_TYPES_CLIENT = 'SET_TYPES_CLIENT'
export const SET_OPTIONS_TRANSPORTEUR = 'SET_OPTIONS_TRANSPORTEUR'
